import { Badge } from "ui/components/badge";
import { PROJECT_STATUS } from "@/modules/work/projects/utils";
import { cn } from "utils";
import { CollapsibleSidebarHeader } from "@/components/nav/sidebar-header";

/**
 * A collapsible project header component that adapts to sidebar state
 * Shows full header when expanded, only logo when collapsed
 * @param {Object} props - Component props
 * @param {Object} props.project - The project data object
 * @param {string} props.project.name - Project name
 * @param {string} props.project.logo - Project logo asset ID
 * @param {string} props.project.status - Project status
 * @param {Array}  props.project.tags - Project tags array
 * @param {boolean} props.isLoading - Whether the project data is loading
 * @param {string} props.className - Additional CSS classes
 */
export function CollapsibleProjectHeader({ project, isLoading = false, className = "" }) {
  if (!project && !isLoading) {
    return null;
  }

  return (
    <CollapsibleSidebarHeader
      title={project?.name}
      subtitle={
        project?.status && (
          <Badge className={cn(PROJECT_STATUS[project.status].className)}>
            {PROJECT_STATUS[project.status].label}
          </Badge>
        )
      }
      logo={project?.logo}
      fallbackText={project?.name?.[0]}
      isLoading={isLoading}
      className={className}
    />
  );
}

